/**
 * Pure view-model helpers for submission comment threads.
 *
 * Intentionally dependency-free so they are trivially unit-testable.
 */

/**
 * Sort a thread's messages into chronological (ascending) order.
 * Returns a new array; the input is not mutated.
 */
export function sortThread<T extends { created_at: string }>(messages: T[]): T[] {
  return [...messages].sort((a, b) => a.created_at.localeCompare(b.created_at));
}

/**
 * Label shown under a comment's attachment. Assumes an attachment exists.
 * Answer attachments (vendor upload, or admin replace) read as the document;
 * an admin's non-answer attachment is a reference example.
 */
export function attachmentLabel(c: {
  author_type: 'admin' | 'vendor';
  attachment_is_answer: boolean;
}): string {
  if (c.attachment_is_answer) return 'Uploaded as the document';
  if (c.author_type === 'admin') return 'Example requested by admin — reference only';
  return 'Attachment';
}
